exports = module.exports = require("../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "a[data-v-cdaab014]{white-space:nowrap}", ""]);

